import { createContext, useContext, useEffect, useState } from "react";

export const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "ta", label: "தமிழ்" },
  { code: "bn", label: "বাংলা" },
  { code: "mr", label: "मराठी" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "ar", label: "العربية" },
];

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("zatayoo_lang") || "en");
  const [translating, setTranslating] = useState(false);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("zatayoo_lang", l);
    setLangState(l);
  };

  return <LanguageContext.Provider value={{ lang, setLang, translating, setTranslating }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
